(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    

  $('.faq-each button').click(function() {

    // display FAQ answer
    var handle = $(this).attr('data-handle');
    var section_id = $(this).attr('data-id');
    $('.answer_' + handle + section_id).toggleClass('active');

    // rotate plus sign indicator
    $(this).toggleClass('active');

  });


  } catch(e) { console.error(e); }
})();
})();
